import * as TYPES from './mutationTypes'

export default {
  //列表
  [TYPES.GET_NODE_MANAGE](state, payload) {
    const { limit, offset, total } = payload.result
    Object.assign(state, {
      node_list: payload.result.items,
      node_paging: { limit, offset, total }
    })
  }
}
